module.exports = __webpack_public_path__ + "static/media/icon-supplies-nailpolish.afe08179.svg";